import * as Types from 'constants/Types'

export const createNewAppUI = (appUI) => ({type: Types.APP_UI_CREATE_ACTION, appUI});
export const updateAppUIConfig = (appUI) => ({type: Types.APP_UI_UPDATE_ACTION, appUI});
export const deleteAppUIConfig = (id) => ({type: Types.APP_UI_DELETE_ACTION, id});

export const createNewAppTranslation = (appUI) => ({type: Types.APP_UI_CREATE_TRANSLATE_ACTION, appUI});
export const updateNewAppTranslation = (appUI) => ({type: Types.APP_UI_UPDATE_TRANSLATE_ACTION, appUI});
export const deleteAppTranslation = (appUI) => ({type: Types.APP_UI_DELETE_TRANSLATE_ACTION, appUI});

export const deleteWhitelistIp = (id) => ({type: Types.WHITELIST_IP_DELETE_IP, id});
export const createWhitelistIp = (ipData) => ({type: Types.WHITELIST_IP_CREATE_IP, ipData});
export const getListHotels = (filters) => ({ type: Types.HOTEL_LIST_ACTION, filters });
